// NOTICED: Refactor it later as a copied and pasted component from src/routes/LandingPage/ObjectivesTab/ObjectivesTab.tsx
/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { PageTab } from '@app/components/Guide/ui/PageTab'
// import { PageTab } from '@app/components/CMS/PageTab'
import { Section } from '@app/components/Guide/ui/Section'
// import { milestoneTableContainer } from '@app/routes/LandingPage/ObjectivesTab/ObjectivesTab.styles'
import { homeMilestonesAtom, homeObjectivesAtom } from '@app/state/HomeAtoms'
import { useAtomValue } from 'jotai'

import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const milestoneTableContainer = (theme: Theme) => css`
  width: 100%;
  border-spacing: 0;
  border-bottom: 2px solid ${theme.palette.uintel.main};

  th {
    text-align: left;
  }
  tbody tr:nth-of-type(odd) {
    background-color: #edf2f4;
  }
  th,
  td {
    padding: 4px 8px;
  }
`

const HomeProjectManagement = () => {
  const theme = useTheme()
  const clientObjectives = useAtomValue(homeObjectivesAtom)
  const milestones = useAtomValue(homeMilestonesAtom)

  return (
    <PageTab
      header="Project management"
      subheader="This page serves to document your organisation’s adaptation goals, deliverables, and evolving priorities."
      tabs={[]}
    >
      <Section id="objectivestab-objectives">
        <h2>Objectives</h2>
        Your key objectives for implementing the Resilience Explorer® include:
        <ul>
          {clientObjectives &&
            clientObjectives?.map((objective, index) => <li key={index}>{objective}</li>)}
        </ul>
      </Section>
      <Section id="objectivestab-milestones">
        <h2>Milestones</h2>
        {milestones ? (
          <table css={milestoneTableContainer(theme)}>
            <thead>
              <tr>
                <th>Milestone</th>
                <th>Deliverable</th>
                <th>Target date</th>
              </tr>
            </thead>
            <tbody>
              {milestones.map((milestone, index) => (
                <tr key={index}>
                  <td>{milestone.name}</td>
                  <td>{milestone.deliverable}</td>
                  <td>{milestone.targetDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <Box>
            <i>Milestones coming soon</i>
          </Box>
        )}
      </Section>
      <Section id="objectivestab-services">
        <h2>Additional services and out-of-schedule requests</h2>
        <h4>Adapting Resilience Explorer® to your evolving needs</h4>
        <p>
          We want to support your resilience journey with flexible, tailored services to meet your
          evolving needs. The following information outlines additional services and requests
          available to you, beyond the standard implementation and support schedule. These services
          ensure flexibility to meet evolving client needs. All services are quoted on an as-needed
          basis.
        </p>
        <br />
        <h4>Out-of-schedule updates</h4>
        <ul>
          <li>Updated data outside that included in your contract</li>
          <li>New data outside that included in your contract</li>
          <li>Additional filterable regions for assessment</li>
          <li>Additional training.</li>
        </ul>
        <br />
        <h4>Related and Additional Services</h4>
        <ul>
          <li>
            Additional Resilience Explorer® Modules: Property Explorer, Prioritisation Explorer
          </li>
          <li>Single Sign On (SSO)</li>
          <li>Bespoke API development</li>
          <li>Full Organisation Data Gap Analysis and Needs Assessment (hazards, elements)</li>
          <li>
            Data enhancement and gap filling (e.g., criticality assessment, access to use of
            proprietary datasets)
          </li>
          <li>Vulnerability, Functionality, and Recovery Curve Generation Workshops</li>
          <li>
            Additional Risk Stories - Supporting resilience consultation with board or community
            groups by delivering customised risk narratives tailored to your stakeholder engagement
            needs
          </li>
          <li>Bespoke Cascading Model Development</li>
          <li>Co-development of new Resilience Explorer® functionalities</li>
          <li>
            Risk Reporting: Climate and Natural Hazard Risk Assessments, Climate-Related Disclosures
          </li>
          <li>Social Vulnerability Assessment</li>
          <li>Economic Vulnerability Assessment</li>
          <li>Client and Stakeholder Engagement</li>
          <li>Adaptation Options Shortlisting</li>
          <li>Adaptation Options Testing</li>
          <li>Business Case Reporting</li>
          <li>
            General advice and support: Guidance on risk and adaptation, data procurement, and
            policy
          </li>
        </ul>
      </Section>
    </PageTab>
  )
}

export default HomeProjectManagement
